export default __webpack_public_path__ + "static/media/PressStart2P.2ebf1a35.ttf";